/* S4: house email capture. One auto-open per visitor, a persistent opener
   pill, Shopify customer form underneath. State in localStorage:
   'done' (subscribed) | 'dismissed'. */
// v2 (17 Sep 2026): the offer changed to the TRY code, so everyone who only
// dismissed the old pop-up sees the new one once. Subscribers stay 'done'.
const KEY = 'sbmd-capture-v2';
const OLD_KEY = 'sbmd-capture-v1';
const AUTO_DELAY = 9000;

const scrim = document.querySelector('.capture-scrim');
const panel = document.getElementById('capture');
const opener = document.querySelector('.capture-opener');
const closeBtn = panel && panel.querySelector('.capture-close');
const formState = panel && panel.querySelector('[data-capture-form-state]');
const successState = panel && panel.querySelector('[data-capture-success]');
const returnInput = panel && panel.querySelector('[data-capture-return]');

const read = () => {
  try { return localStorage.getItem(KEY) || ''; } catch (e) { return ''; }
};
const write = (v) => {
  try { localStorage.setItem(KEY, v); } catch (e) { /* private mode */ }
};
try {
  if (!localStorage.getItem(KEY) && localStorage.getItem(OLD_KEY) === 'done') write('done');
  localStorage.removeItem(OLD_KEY);
} catch (e) { /* private mode */ }

function open(success) {
  if (!panel) return;
  if (success) {
    formState.hidden = true;
    successState.hidden = false;
  }
  document.documentElement.classList.add('capture-open');
  panel.setAttribute('aria-hidden', 'false');
  opener && opener.setAttribute('aria-expanded', 'true');
  // focus after the panel's visibility transition begins — focusing a
  // still-hidden element silently fails and strands keyboard users on
  // the opener behind the dialog (C7)
  setTimeout(() => {
    if (!success) {
      const email = panel.querySelector('.capture-input');
      email && email.focus({ preventScroll: true });
    } else {
      closeBtn && closeBtn.focus({ preventScroll: true });
    }
  }, 80);
}

function close(reason) {
  if (!panel) return;
  document.documentElement.classList.remove('capture-open');
  panel.setAttribute('aria-hidden', 'true');
  opener && opener.setAttribute('aria-expanded', 'false');
  if (reason === 'dismiss' && read() !== 'done') write('dismissed');
  opener && opener.focus({ preventScroll: true });
}

if (panel) {
  // the form returns to the page it was sent from, marked as posted
  if (returnInput) {
    const q = location.search ? location.search + '&customer_posted=true' : '?customer_posted=true';
    // sbmd_signup=popup tells the lead report below which form was used
    returnInput.value = location.pathname + q + '&sbmd_signup=popup';
  }

  const posted = new URLSearchParams(location.search).has('customer_posted');
  const errored = !!panel.querySelector('.capture-error');

  if (posted) {
    write('done');
    if (opener) opener.hidden = true;
    open(true);
  } else if (errored) {
    open(false);
  } else if (!read()) {
    setTimeout(function tryOpen() {
      if (read()) return; // dismissed or subscribed since the timer was set
      // never stack on top of the menu drawer
      if (document.documentElement.classList.contains('drawer-open')) {
        setTimeout(tryOpen, 15000);
        return;
      }
      open(false);
    }, AUTO_DELAY);
  }

  if (read() === 'done' && opener) opener.hidden = true;

  // post the letter: fold the card away, then let the real submit follow
  const form = panel.querySelector('.capture-form');
  let folded = false;
  form && form.addEventListener('submit', (e) => {
    if (folded) return;
    e.preventDefault();
    panel.classList.add('posting');
    const finish = () => { folded = true; form.requestSubmit(); };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
    else setTimeout(finish, 600);
  });

  opener && opener.addEventListener('click', () => open(false));
  closeBtn && closeBtn.addEventListener('click', () => close('dismiss'));
  scrim && scrim.addEventListener('click', () => close('dismiss'));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && document.documentElement.classList.contains('capture-open')) close('dismiss');
  });
}

// Footer signup, product pages (23 Sep 2026): they load pdp.js instead of
// engine.js, so the footer form there still
// returns to "/" with no marker: give it the same return path.
document.querySelectorAll('[data-signup-return]').forEach((inp) => {
  if (inp.value !== '/') return;
  const q = location.search ? location.search + '&customer_posted=true' : '?customer_posted=true';
  inp.value = location.pathname + q;
});

// Lead report (23 Sep 2026): a successful Shopify customer-form signup, from
// the pop-up above or the footer (engine.js, or the block above, sets its return path),
// comes back with customer_posted=true. Publish sbmd_newsletter_lead once;
// the admin custom pixel "SBMD custom events (GA4+Meta)" forwards it to GA4
// as generate_lead and to Meta as Lead (docs/LEARN-CAPTURE.md, pixel v3).
// The two params are then dropped from the address bar so a reload or a
// shared link can't count the same signup twice.
(function reportSignup() {
  const params = new URLSearchParams(location.search);
  if (!params.has('customer_posted')) return;
  if (document.querySelector('.capture-error, .signup-note.err')) return;
  const source = params.get('sbmd_signup') === 'popup' ? 'popup' : 'footer';
  const tidy = () => {
    try {
      params.delete('customer_posted');
      params.delete('sbmd_signup');
      const rest = params.toString();
      history.replaceState(history.state, '', location.pathname + (rest ? '?' + rest : '') + location.hash);
    } catch (e) { /* never block the page */ }
  };
  let tries = 0;
  (function send() {
    const a = window.Shopify && window.Shopify.analytics;
    if (a && typeof a.publish === 'function') {
      try { a.publish('sbmd_newsletter_lead', { source: source }); } catch (e) { /* never block the page */ }
      tidy();
      return;
    }
    if (++tries < 40) setTimeout(send, 250);
  })();
})();
